export const GROWTH_URL = '/ccg';

// URL path keywords
export const GROWTH_KEYWORD = 'ccg';
export const ON24_URL_KEYWORD = 'webcasts';
export const CCT_TODOLIST = 'todo';
export const THROUGHLINE_URL_KEYWORD = 'throughline';

export const GROWTH_ROUTES = {
	THROUGHLINE: '/apps/throughline/photoshop',
};

// Add cchome-react config in ./config.js
export const GROWTH_WORKFLOWS = {
	ON24: 'on24',
	NOT_VALID: 'notAGrowthWorkflow',
	THROUGHLINE: 'throughline',
	TODOLIST: 'todolist',
	CCT_TODOLIST: 'cct-todolist',
};
